"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var Checkbox = {
  styles: function styles(theme) {
    return {
      label: {
        fontSize: 14
      },
      labelText: {
        color: theme.colors.baseContrast085
      },
      hint: {
        fontSize: 12
      },
      svg: {
        stroke: theme.colors.textOnDark
      },
      input: {
        "& + label svg": {
          borderWidth: 1,
          padding: 1
        }
      }
    };
  }
};
var _default = exports.default = Checkbox;